<template lang="pug">
  .help-info
    img.top-bg(src="../../../assets/help/help-bg01.png")
    .draw-enter 查看奖品
    .draw-btn 发起好友助力（0/ {{helpItem.num}})
    img.middel-raduis(src='https://chedian-oss1.vchangyi.com/help-activity/split-bg.png')
    .rules-box
      img.bg-bottom(src="../../../assets/help/help-bg02.png")
      .rule-title 活动规则：
      .rule-content(v-for="item in content_list" v-text="item")
</template>

<script type="span/ecmascript-6">
export default {
  name: 'Help',
  props: {
    helpItem: {
      type: Object,
      default: () => { },
    },
  },
  watch: {
    'helpItem.rule': function () {
      let arr = []
      if (this.helpItem.rule) {
        arr = this.helpItem.rule.split(/\n/);
      }
      this.content_list = arr
    },
  },
  data () {
    return {
      content_list: []
    }
  },
  methods: {},
  mounted () {
    let arr = []
    if (this.helpItem.rule) {
      arr = this.helpItem.rule.split(/\n/);
    }
    this.content_list = arr
  },
}
</script>

<style scoped lang="stylus">
.help-info
  position: relative
  margin-bottom: 15px
  min-height: 344px
  font-size 0
  padding-bottom 30px
  word-wrap break-word
  background linear-gradient(360deg,rgba(251,206,7,1) 0%,rgba(255,155,0,1) 100%)
  .top-bg
    width 327px
    height 196px
    margin 12px 0 0 9px
  .draw-enter
    width 68px
    height 25px
    color white
    font-size 11px
    line-height 25px
    font-weight 500
    background-image url('~@/assets/help/help-draw.png')
    background-size 68px 25px
    background-position 0 0
    background-repeat no-repeat
    text-align center
    position absolute
    top 46px
    right 0
  .draw-btn
    width 285px
    height 39px
    color white
    font-size 15px
    line-height 39px
    font-weight 500
    background-image url('~@/assets/help/help-btn.png')
    background-size 285px 39px
    background-position 0 0
    background-repeat no-repeat
    text-align center
    position absolute
    top 137px
    left 32px
  .middel-raduis
    width 333px
    height 24px
    padding-left 17px
  .rules-box
    width 313px
    min-height 105px
    background linear-gradient(180deg,rgba(255,155,0,1) 0%,rgba(255,62,0,1) 100%);
    margin-left 18px
    box-sizing border-box
    padding 18px 21px
    font-size:13px
    position relative
    color:rgba(255,255,255,1)
    margin-top -1px
    .bg-bottom
      width 210px
      height 105px
      position absolute
      bottom 0
      right 0
    .rule-title
      position relative
      z-index 2
      line-height:18px
    .rule-content
      line-height:24px
      position relative
      z-index 2
</style>



// WEBPACK FOOTER //
// src/components/content/modal/Help.vue